export default __webpack_public_path__ + "60e854d2149ded7983e6d5fa6b0eec5d.js";